import ModeloList from './list'
import ModeloCreate from "./create";
import ModeloEdit from './edit'


export default {
    list : ModeloList,
    edit : ModeloEdit,
    create : ModeloCreate,
}